import React from 'react';
import { Box,Fab, GridLegacy } from '@mui/material';
// import List from '@mui/material/List';
// import ListItemButton from '@mui/material/ListItemButton';
// import ListItemIcon from '@mui/material/ListItemIcon';
// import ListItemText from '@mui/material/ListItemText';
import CustomizedTable, { createData } from '../../Common_Components/List_Table/list_table';
import Backdrop from '@mui/material/Backdrop';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import FileDownload from '@mui/icons-material/FileDownload'
import FileUpload from '@mui/icons-material/FileUpload'
import { /* get_all_recorded_rows, */get_all_recoded_children_names,get_all_recoded_children } from '../../../db';
import { read_file_as_string } from '../../../util';
import { useSelector } from 'react-redux';
import {TEXT} from './text';
import { AppGlobalContext } from '../../../App';





// const actions = [
//   { icon: < FileUpload/>, name: 'Import'   ,callback:},
//   { icon: < FileDownload/>, name: 'Export' ,callback:},
// ];

export function SpeedDialTooltipOpen(props) {
  const language = useSelector(state => state.App_Settings.language);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  
  return (
    <Box sx={{ height: 330, transform: 'translateZ(0px)', flexGrow: 1 }}>
      <Backdrop open={open} />
      <SpeedDial
        ariaLabel="SpeedDial tooltip example"
        sx={{ position: 'absolute', bottom: 16, right: 16 }}
        icon={<SpeedDialIcon />}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
      >
        <SpeedDialAction
        key={'Export'}
        icon={< FileDownload/>}
        tooltipTitle={TEXT.Export[language]}
        tooltipOpen
        onClick={()=>{props.Registed_Actions_Export();console.log('Export')}/*()=>{props.Registed_check_import_json(document.querySelector('input#json_input'))}*/}
        />
        <SpeedDialAction
        key={'Import'}
        icon={< FileUpload/>}
        tooltipTitle={TEXT.Import[language]}
        tooltipOpen
        onClick={()=>document.querySelector('input#json_input').click() /*()=>{props.Registed_check_import_json(document.querySelector('input#json_input'))}*/}
        />
      </SpeedDial>
    </Box>
  );
}


function Registed_page_body(props)
{
  const language = useSelector(state => state.App_Settings.language);
  const [rows, setRows] = React.useState(window.all_registed_childrens.map((data) => createData(...[ data.Name, data.Class, data.Address ])));
  const [selected_count, setSelected_count] = React.useState(0);
  const AppGlobalContxt = React.useContext(AppGlobalContext);
  
  const Registed_table_refresh = async() => {
    let myreq = window.db.transaction(["children"], "readwrite").objectStore("children").getAll()
    myreq.onerror = (event) => console.log(event);

    myreq.onsuccess = () => {
        window.all_registed_childrens = myreq.result
    }
    setRows(await window.all_registed_childrens.map((data) => createData(...[ data.Name, data.Class, data.Address ])))
     console.log("refresh_all_registed_childrens");
  }
      async function Registed_check_import_json(input_element) {
        try {
            if (input_element.files.length) {
                const json_content = await read_file_as_string(input_element.files[0])
                const ImportedObj = JSON.parse(json_content)
                if (ImportedObj.length) {
                    const recorded_names = await get_all_recoded_children_names()
                    const new_records = ImportedObj.filter((imported_record) => !recorded_names.includes(imported_record.Name))
                    const myidb = window.idb
                    const tx = myidb.transaction(['children'], 'readwrite')
                    const ob = tx.objectStore('children')
      
                    let adding_promises = new_records.map((new_record) => ob.put(new_record))
                    await Promise.all([...adding_promises, tx.done])
                    Registed_table_refresh()
                }
            }
        }
        catch (any) {
            console.error(any)
        }
      }
      
      async function Registed_Actions_Import() {
        document.querySelector("input#json_input").click()
      }
      async function Registed_Actions_Export() {
        var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(await get_all_recoded_children()));
        var dlAnchorElem = document.getElementById('downloadAnchorElem');
        dlAnchorElem.setAttribute("href", dataStr);
        dlAnchorElem.setAttribute("download", "children_db" + Date.now().toString() + ".json");
        dlAnchorElem.click();
      }


  return (
    <GridLegacy container>
            <Fab color="secondary" aria-label="add" sx={{ position: 'fixed', top: 70, left: 16 }}
                onClick={() => {
                    AppGlobalContxt.Body.setPageName("Home")
                }
                }  >
                <ArrowBackIcon />
            </Fab>
      <GridLegacy item xs={12}>
      <br/>
      <br/>
      <CustomizedTable 
        header_cells={[
                TEXT.Name[language],//"Name",
                TEXT.Class[language],//"Class",
                TEXT.Address[language],//"Address"
              ]} 
        columns_align={['left','right','right']}
        rows={rows}
        setRows={setRows}
        selected_count={selected_count}
        setSelected_count={setSelected_count} />
      </GridLegacy>
      <GridLegacy item minHeight={0}> </GridLegacy>
      <GridLegacy item>
        <Box>
          <SpeedDialTooltipOpen Registed_check_import_json={Registed_check_import_json} Registed_Actions_Export={Registed_Actions_Export} />
          <input type="file" id="json_input" hidden={true} accept=".json,application/json"
                    onChange={(e) => {Registed_check_import_json(e.target)}}></input>
          <a id="downloadAnchorElem" hidden={true}></a>
        </Box>
      </GridLegacy>
    </GridLegacy>
  )
}

export default Registed_page_body;
